import { ToastProgrammatic as Toast } from 'buefy';
import dayjs from 'dayjs';

import { resetPasswordWithToken } from '@/api/user';

export default {
  name: 'ResetPasswordVerification',
  data() {
    return {
      errors: {
        messages: [],
        title: '',
      },
      isLoading: false,
      password: null,
    };
  },
  computed: {
    isSucceed() {
      return !this.isLoading && !this.errors.messages?.length;
    },
  },
  beforeDestroy() {
    Object.assign(this.$data, this.$options.data.apply(this));
  },
  async created() {
    this.isLoading = true;
    const { confirmation_token: token } = this.$route?.query || {};
    if (!token) {
      Toast.open({
        message: '無法取得驗證碼，請確認驗證資料無誤。',
        type: 'is-danger',
      });
      this.$router.replace('/');
      return;
    }
    try {
      const { new_password: pwd = '' } = await resetPasswordWithToken(token);
      this.password = pwd;
    } catch (error) {
      const errorStatuses = {
        5005: {
          messages: ['其它管理員已為此成員重置密碼。'],
          title: '密碼已由其它管理員重置',
        },
        5007: {
          messages: ['請組織成員重新送出重置密碼申請。'],
          title: '已過期失效',
        },
      };
      this.errors = errorStatuses?.[error?.status] || {
        messages: ['密碼重置失敗，需請組織成員重新送出申請。'],
        title: '密碼重置失敗',
      };
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    dayjs,
  },
};
